import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { DocumentViewComponent } from './document-view/document-view.component';
import { SearchComponent } from './search.component';

const routes: Routes = [
    {path: 'ViewDocument', component: DocumentViewComponent} ,
    {path: '', component: SearchComponent}
 ];

@NgModule({
  imports: [BrowserModule,RouterModule.forRoot(routes)],
  exports:[RouterModule],
  declarations: [],
  bootstrap: [],
})
export class SearchRoutingModule {}
